export default __webpack_public_path__ + "static/concierge_service-a7e58cd34c05c0990f65c6fed3cd4078.jpg";